import en from './en.json';
import fr from './fr.json';
import fi from './fi.json';
import es from './es.json';
import sv from './sv.json';
import nl from './nl.json';

export default {
  en,
  fr,
  fi,
  es,
  sv,
  nl,
};
